export const invalidateOn = <T>({ success = [], error = [] }: { success?: T[]; error?: T[] }) => {
  return (result: unknown) => (result !== undefined ? success : error);
};
